import { useEffect } from 'react'
import { useClientAccessStore } from '~/stores/clientAccessStore'
import getDeviceInfo from '~/utils/get-device-info'

export function useDeviceInfo() {
  const { setDeviceInfo } = useClientAccessStore()

  useEffect(() => {
    setDeviceInfo({
      os: getDeviceInfo().os,
      isMobile: getDeviceInfo().isMobile,
    })
  }, [setDeviceInfo])
}
